import { render, staticRenderFns } from "./qrcode.vue?vue&type=template&id=3234c56b&"
import script from "./qrcode.vue?vue&type=script&lang=js&"
export * from "./qrcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports